export default __webpack_public_path__ + "static/media/passExample.d7fb6e1d.jpg";